import React, { useEffect, Component } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import routes from '../../routes';

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            autoClose: 3000,
            position: 'top-center',
            theme: 'light'
        };
    }

    componentWillMount() {
        this.toastModal();
    }

    componentDidMount() {
        // const { autoClose } = this.state;
        // setTimeout(() => this.onNavigate(), autoClose);
    }

    onNavigate = () => {
        const { path, props: { history } } = this.props;
        history.push('/' + routes.mainRoute + '/' + path);
    }

    toastModal = () => {
        const { status='', msg='' } = this.props;
        const { autoClose=3000, position='top-center', theme='light' } = this.props;

        const toastConstant = {
            position: position,
            autoClose: autoClose,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: theme,
            onClose: () => {}
        }

        if (status == "Success") {
            toast.success(msg, toastConstant);
        } else if (status == "Fail" || status == "Failed") {
            toast.error(msg, toastConstant);
        }
    }

    render() {
        const { autoClose, position, theme } = this.props;
        return <ToastContainer
            position={position}
            autoClose={autoClose}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={theme}
        />
    }
}


export default index;